"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEntity = exports.PasswordStrength = void 0;
const zxcvbn_1 = __importDefault(require("zxcvbn"));
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const LocationDto_1 = require("../locations/LocationDto");
const LocationEntity_1 = require("../locations/LocationEntity");
const Operator_1 = require("../GS/Operator");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const UserDto_1 = require("./UserDto");
const ValidationError_1 = require("../GS/ValidationError");
var PasswordStrength;
(function (PasswordStrength) {
    PasswordStrength[PasswordStrength["VERY_WEAK"] = 0] = "VERY_WEAK";
    PasswordStrength[PasswordStrength["WEAK"] = 1] = "WEAK";
    PasswordStrength[PasswordStrength["MODERATE"] = 2] = "MODERATE";
    PasswordStrength[PasswordStrength["STRONG"] = 3] = "STRONG";
    PasswordStrength[PasswordStrength["VERY_STRONG"] = 4] = "VERY_STRONG";
})(PasswordStrength = exports.PasswordStrength || (exports.PasswordStrength = {}));
class UserEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, user) {
        super();
        this._requiredFieldsSetStatus = {
            userName: false,
            firstName: false,
            lastName: false,
            email: false,
            role: false,
            status: false,
            password: false
        };
        this._dependencies = dependencies;
        if (user === undefined) {
            this._dto = new UserDto_1.UserDto();
        }
        else if (user instanceof UserDto_1.UserDto) {
            this._dto = new UserDto_1.UserDto(user);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (user instanceof UserEntity) {
            this._dto = new UserDto_1.UserDto(user._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new UserDto_1.UserDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getUserName() {
        return this._dto.userName;
    }
    setUserName(untrustedValue) {
        const minLength = 3;
        const maxLength = 40;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("userName");
        this._requiredFieldsSetStatus.userName = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("userName", "User Name is required."));
        }
        else if (_untrustedValue.length < minLength) {
            this.addError(new ValidationError_1.ValidationError("userName", `User Name is below the minimum length (${minLength} chr).`));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("userName", `User Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.userName) {
            return;
        }
        this._dto.userName = _untrustedValue;
        this._setIsDirty(true);
    }
    getFirstName() {
        return this._dto.firstName;
    }
    setFirstName(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("firstName");
        this._requiredFieldsSetStatus.firstName = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("firstName", "First Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("firstName", `First Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.firstName) {
            return;
        }
        this._dto.firstName = _untrustedValue;
        this._setIsDirty(true);
    }
    getLastName() {
        return this._dto.lastName;
    }
    setLastName(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("lastName");
        this._requiredFieldsSetStatus.lastName = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("lastName", "Last Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("lastName", `Last Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.lastName) {
            return;
        }
        this._dto.lastName = _untrustedValue;
        this._setIsDirty(true);
    }
    getEmail() {
        return this._dto.email;
    }
    setEmail(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("email");
        this._requiredFieldsSetStatus.email = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("email", "Email is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("email", `Email has exceeded the maximum length (${maxLength} chr).`));
        }
        else if (!validators_1.isEmail(_untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("email", "Email is invalid."));
        }
        if (!this.isNew && _untrustedValue === this._dto.email) {
            return;
        }
        this._dto.email = _untrustedValue;
        this._setIsDirty(true);
    }
    getPhone() {
        return this._dto.phone;
    }
    setPhone(untrustedValue) {
        const maxLength = 30;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("phone");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("phone", `Phone has exceeded the maximum length (${maxLength} chr).`));
        }
        else if (_untrustedValue &&
            !validators_1.isMobilePhone(_untrustedValue, ["en-US", "en-CA"])) {
            this.addError(new ValidationError_1.ValidationError("phone", "Phone is invalid."));
        }
        if (!this.isNew && _untrustedValue === this._dto.phone) {
            return;
        }
        this._dto.phone = _untrustedValue;
        this._setIsDirty(true);
    }
    getRole() {
        return this._dto.role;
    }
    setRole(untrustedValue) {
        const maxLength = 30;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("role");
        this._requiredFieldsSetStatus.role = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("role", "Role is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("role", `Role has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.role) {
            return;
        }
        this._dto.role = _untrustedValue;
        this._setIsDirty(true);
    }
    getStatus() {
        return this._dto.status;
    }
    setStatus(untrustedValue) {
        const maxLength = 15;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("status");
        this._requiredFieldsSetStatus.status = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("status", "Status is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("status", `Status has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.status) {
            return;
        }
        this._dto.status = _untrustedValue;
        this._setIsDirty(true);
    }
    getPassword() {
        return this._dto.password;
    }
    setPassword(untrustedValue) {
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("password");
        this._requiredFieldsSetStatus.password = true;
        if (_untrustedValue.length === 0) {
            if (this.isNew) {
                this.addError(new ValidationError_1.ValidationError("password", "Password is required."));
            }
        }
        else {
            const passwordCheckResult = zxcvbn_1.default(_untrustedValue);
            if (passwordCheckResult.score < PasswordStrength.MODERATE) {
                this.addError(new ValidationError_1.ValidationError("password", "Password is not strong enough. (" +
                    passwordCheckResult.crack_times_display.online_no_throttling_10_per_second +
                    " to guess)"));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.password) {
            return;
        }
        this._dto.password = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    getAlertNotificationSettings() {
        return this._dto.alertNotificationSettings;
    }
    setAlertNotificationSetting(name, enabled) {
        this._dto.alertNotificationSettings[name] = enabled;
        this._setIsDirty(true);
    }
    setAlertNotificationSettings(alertNotificationSettings) {
        for (const settingName of Object.keys(alertNotificationSettings)) {
            this._dto.alertNotificationSettings[settingName] =
                alertNotificationSettings[settingName];
        }
        this._setIsDirty(true);
    }
    getApps() {
        var _a, _b;
        if (this.isNew) {
            return undefined;
        }
        if (this._dto.locations === undefined ||
            (this._dto.locations.length > 0 &&
                (this._dto.locations[0].appVersion === undefined ||
                    ((_a = this._dto.locations[0].appVersion) === null || _a === void 0 ? void 0 : _a.app) === undefined))) {
            throw new Error("Cannot call getApps without first " +
                "loading the locations.appVersion.app.");
        }
        const uniqueApps = [];
        (_b = this.getLocations()) === null || _b === void 0 ? void 0 : _b.forEach((location) => {
            var _a;
            const app = (_a = location.getAppVersion()) === null || _a === void 0 ? void 0 : _a.getApp();
            if (app &&
                !uniqueApps.find((uniqueApp) => (uniqueApp.getId() === (app === null || app === void 0 ? void 0 : app.getId())))) {
                uniqueApps.push(app);
            }
        });
        return uniqueApps;
    }
    setApps(apps) {
        throw new Error("Cannot set Apps using setApps. " +
            "Apps are set when Locations are set.");
    }
    addApp(app) {
        throw new Error("Cannot add Apps using addApp. " +
            "Apps are add when a Location with a new App is added.");
    }
    removeApp(app) {
        throw new Error("Cannot remove Apps using removeApp. " +
            "Apps are removed when all Locations for an App are removed.");
    }
    loadAppsAsync() {
        throw new Error("Cannot load Apps using loadAppsAsync. " +
            "Apps are loaded when Locations are loaded.");
    }
    getLocations() {
        var _a;
        if (this.isNew) {
            return undefined;
        }
        if (this._dto.locations === undefined) {
            throw new Error("Cannot call getLocations without first loading the locations.");
        }
        if (!this._locationEntities && this._dto.locations) {
            this._locationEntities = (_a = this._dto.locations) === null || _a === void 0 ? void 0 : _a.map((locationDto) => new LocationEntity_1.LocationEntity(this._dependencies, locationDto));
        }
        return this._locationEntities;
    }
    setLocations(locations) {
        this._dto.locations = locations.map((location) => {
            if (location instanceof LocationEntity_1.LocationEntity) {
                return new LocationDto_1.LocationDto(location.toDto());
            }
            return new LocationDto_1.LocationDto(location);
        });
        delete this._locationEntities;
        this._setIsDirty(true);
    }
    addLocation(location) {
        if (this._dto.locations === undefined) {
            throw new Error("Cannot call addLocation without first loading the locations.");
        }
        if (!this._dto.locations) {
            this._dto.locations = [];
        }
        this._dto.locations.push(location.toDto());
        if (this._locationEntities) {
            this._locationEntities.push(new LocationEntity_1.LocationEntity(this._dependencies, location));
        }
        this._setIsDirty(true);
    }
    removeLocation(location) {
        let locationId;
        if (location instanceof LocationEntity_1.LocationEntity) {
            locationId = location.getId();
        }
        else if (location instanceof LocationDto_1.LocationDto) {
            locationId = location.id;
        }
        else if (typeof location === "string") {
            locationId = parseInt(location, 10);
        }
        else {
            locationId = location;
        }
        if (this._dto.locations) {
            this._dto.locations = this._dto.locations.filter((locationDto) => (locationDto.id !== locationId));
        }
        if (this._locationEntities) {
            this._locationEntities = this._locationEntities.filter((_location) => (_location.getId() !== locationId));
        }
        this._setIsDirty(true);
    }
    loadLocationsAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-loadLocationsAsync");
                this._dto.locations = (yield this._dependencies.locationDatastore.findAsync({
                    selector: { "user.id": { [Operator_1.Operator.EQUALS_TO]: this.getId() } },
                    sort: [{ name: "asc" }],
                    expand
                })).dtos;
                delete this._locationEntities;
                this._emit("after-loadLocationsAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.userDatastore
                    .getAsync(id, expand);
                delete this._locationEntities;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("User is not in a valid state.");
                }
                let dto = this.toDto();
                if (dto.locations) {
                    dto.locations = (_a = dto.locations) === null || _a === void 0 ? void 0 : _a.map((location) => ({ id: location.id }));
                }
                if (this.isNew) {
                    dto = yield this._dependencies.userDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.userDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                if (this.isNew) {
                    this._dto.locations = this._dto.locations || [];
                }
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("User cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.userDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.UserEntity = UserEntity;
//# sourceMappingURL=UserEntity.js.map